<template>
    <div v-if="!isInSession" class="open-session"
        :class="{
            'iphone-x-fit': enableFooterIphonexStyle,
            'is-mobile': isMobile,
            'is-desktop': isDesktop
        }">
        <div class="open-session-btn" :style="openSessionBtnStyle" @click="openSession">
            <i class="icon_huihua"></i>
            <span>重新建立会话</span>
        </div>
    </div>
    <div class="footer"
        :class="{
            'iphone-x-fit': enableFooterIphonexStyle,
            'is-typing-focus': isTypingFocus,
            'is-recording': isVoiceRecording,
            [activeAction]: true
        }"
        v-click-outside="clickOutSideConfig"
        v-else>
        <div class="footer__addition">
            <!-- S 热点词汇 -->
            <the-hot-words
                v-if="isShowHotWords"
                :hotWords="hotWords" />
            <!-- E 热点词汇 -->

            <!-- S 猜你想问 -->
            <the-related-question
                v-if="isShowRelatedQuestion"
                ref="theRelatedQuestion"
                :relatedQuestion="relatedQuestion"
                :keyword="relatedQuestionKeyword"
                @setTypingContent="setTypingContent"
                @focusIfBlur="focusIfBlur"
                @clearRelatedQuestion="clearRelatedQuestion" />
            <!-- E 猜你想问 -->

            <!-- S 语音录制时的提示 -->
            <div class="voice-recording-tips"
                v-if="isVoiceRecording">
                手指上滑，取消发送
            </div>
            <!-- E 语音录制时的提示 -->
        </div>

        <div class="footer__main">
            <!-- S top for desktop -->
            <div class="footer__main-top"
                v-if="isDesktop">
                <div class="action">
                    <div class="action__item action__item--no-active"
                        @click="toggleEmojiPanel">
                        <div class="action__icon icon_emoji"></div>
                    </div>
                    <div class="action__item action__item--no-active"
                        @click="triggerClickOtherPanelItem('photo')">
                        <div class="action__icon icon_photo"></div>
                    </div>
                    <div class="action__item action__item--no-active"
                        @click="triggerClickOtherPanelItem('file')">
                        <div class="action__icon icon_file"></div>
                    </div>
                    <div class="action__item action__item--no-active"
                        @click="triggerClickOtherPanelItem('video')">
                        <div class="action__icon icon_video"></div>
                    </div>
                </div>
            </div>
            <!-- E top for desktop -->

            <!-- S middle for mobile，与 desktop 共用输入框 -->
            <div class="footer__main-middle">
                <!-- S 输入框左边的图标 -->
                <!-- 微信环境下显示语音图标 -->
                <div class="action action--left"
                    v-if="isMobile && isWechat && nowxwork">
                    <template v-if="isMobile && isWechat && nowxwork">
                        <!-- S 上传图片 -->
                        <!-- <div class="action__item action__item--upload-img"
                            @click="closeAllPanel">
                            <van-uploader
                                name="photo"
                                accept="image/*"
                                :max-count="UPLOAD_MAX_COUNT"
                                :before-read="beforeRead"
                                :after-read="afterRead">
                                <div class="action__icon icon_photo"></div>
                            </van-uploader>
                        </div> -->
                        <!-- E 上传图片 -->

                        <!-- S 语音 or 键盘 切换 -->
                        <div class="action__item action__item--voice"
                            v-if="chatInputType === INPUT_TYPE.TYPING"
                            @click="switchToVoiceInput">
                            <div class="action__icon icon_voice"></div>
                        </div>
                        <div class="action__item action__item--keyboard"
                            v-else
                            @click="switchToTypingInput">
                            <div class="action__icon icon_keyboard"></div>
                        </div>
                        <!-- E 语音 or 键盘 切换-->

                        <!-- S 返回失焦 -->
                        <!-- <div class="action__item action__item--blur"
                            @click="closeAllPanel">
                            <div class="action__icon icon_expansion"></div>
                        </div> -->
                        <!-- E 返回失焦 -->
                    </template>
                </div>
                <!-- S 输入框左边的图标 -->

                <!-- S 输入框 -->
                <div class="chat-input">
                    <!-- E 打字输入框 -->
                    <div class="chat-input__typing"
                        v-show="chatInputType === INPUT_TYPE.TYPING">
                        <!-- S 编辑器 contenteditable 不支持 @change -->
                        <div class="editor">
                            <div class="editor__input"
                                :class="{
                                    'is-empty': isShowTypingPlaceholder
                                }"
                                ref="chatInputTyping"
                                contenteditable="true"
                                :data-placeholder="typingPlaceholder"
                                type="search"
                                @input="inputByTyping"
                                @focus="focusChatInput"
                                @blur="blurChatInput"
                                @keydown.enter.exact.prevent.stop="enterKey"
                                @keydown.ctrl.enter.exact.prevent.stop="createNewLine"
                                @paste.prevent="paste"
                                @compositionstart="compositionstart"
                                @compositionend="compositionend"></div>
                        </div>
                        <!-- E 编辑器 -->
                        <!-- <div class="action__item action__item--send"
                            v-if="isMobile && hasTypingContent"
                            @click="sendTypingContent">
                            <div class="action__icon">
                                <icon name="send" :width="18" :height="18" />
                            </div>
                        </div> -->

                    </div>
                    <!-- E 打字输入框 -->

                    <!-- S 语音输入框 -->
                    <div class="chat-input__voice"
                        :class="{
                            'is-active': isVoiceRecording
                        }"
                        v-show="chatInputType === INPUT_TYPE.VOICE"
                        @click.stop.prevent
                        @touchstart.stop.prevent="startVoiceRecording"
                        @touchend.stop.prevent="endVoiceRecording"
                        @touchmove.stop.prevent="detectCancelVoiceRecording">
                        {{ voiceInputPlacehoder }}
                    </div>
                    <!-- E 语音输入框 -->
                </div>
                <!-- E 输入框 -->

                <!-- S 输入框右边的图标 -->
                <div class="action action--right"
                    v-if="isMobile">
                    <!-- S 表情入口 -->
                    <div class="action__item action__item--emoji"
                        @click="toggleEmojiPanel"
                        v-if="isMobile">
                        <div class="action__icon icon_emoji"></div>
                    </div>
                    <!-- E 表情入口 -->
                    <!-- S 其他 -->
                    <div
                        v-if="!hasTypingContent"
                        class="action__item action__item--other"
                        @click="toggleOtherPanel">
                        <div class="action__icon icon_function"></div>
                    </div>
                    <button
                        v-if="hasTypingContent"
                        class="send-btn"
                        :class="{
                            'able-submit': hasTypingContent
                        }"
                        :style="{background: color}"
                        @click="clickSendBtnOfDesktop">发送</button>
                    <!-- E 其他 -->
                    <!-- <div class="action__item action__item--extend"
                        v-else
                        @click="toggleExtendPanel">
                        <div class="action__icon icon_extend"></div>
                    </div> -->
                </div>
                <!-- E 输入框右边的图标 -->
            </div>
            <!-- E middle for mobile，与 desktop 共用输入框 -->

            <!-- S bottom for desktop -->
            <div class="footer__main-bottom"
                v-if="isDesktop">
                <div class="send-wrap">
                    <div class="send-tips">按Enter 键发送，按Ctrl+Enter键换行</div>
                    <button class="send-btn"
                        :class="{
                            'able-submit': hasTypingContent
                        }"
                        :style="{background: color}"
                        @click="clickSendBtnOfDesktop">发送</button>
                </div>
            </div>
            <!-- E bottom for desktop -->
        </div>

        <!-- S 面板 -->
        <div class="footer__panel">
            <the-extend-panel
                :isShow.sync="isShowExtendPanel"
                :type="extendType"
                :extendData="extendData"></the-extend-panel>
            <the-other-panel
                :isShow.sync="isShowOtherPanel"
                @closeAllPanel="closeAllPanel"></the-other-panel>
            <the-emoji-panel
                :isShow.sync="isShowEmojiPanel"
                :typingContent.sync="typingContent"></the-emoji-panel>
        </div>
        <!-- E 面板 -->
    </div>
</template>

<script>
    import { TRIGGER_CLICK_OTHER_PANEL_ITEM } from '@/constants/pub_sub'
    import {
        isValidFileType,
        UPLOAD_MAX_COUNT,
        UPLOAD_ACCEPT_TYPE_IMAGE
    } from '@/utils/upload'
    // import Icon from '@/components/Icon'
    import TheExtendPanel from './components/TheExtendPanel'
    import TheOtherPanel from './components/TheOtherPanel'
    import TheEmojiPanel from './components/TheEmojiPanel'
    import TheHotWords from './components/TheHotWords'
    import TheRelatedQuestion from './components/TheRelatedQuestion'
    import typingMixin from './mixins/typing'
    import voiceMixin from './mixins/voice'
    import { uploadImgBusiness } from './utils/upload_business'
    import { getRequest } from '@/utils'

    const INPUT_TYPE = {
        TYPING: 'typing',
        VOICE: 'voice'
    }

    export default {
        name: 'TheFooter',
        mixins: [
            typingMixin,
            voiceMixin
        ],
        components: {
            // Icon,
            TheExtendPanel,
            TheOtherPanel,
            TheEmojiPanel,
            TheHotWords,
            TheRelatedQuestion
        },
        props: {
            extendType: {
                type: String,
                required: true
            },
            extendData: {
                type: Array,
                required: true
            },
            hotWords: {
                type: Object,
                required: true
            },
            relatedQuestion: {
                type: Array,
                required: true
            },
            chatTarget: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                // todo: 移动端限制类型时，安卓 会出现选中图片后无法发送bug，故此处删除类型限制
                UPLOAD_ACCEPT_TYPE_IMAGE,
                UPLOAD_MAX_COUNT,
                INPUT_TYPE,
                chatInputType: INPUT_TYPE.TYPING,
                isShowExtendPanel: false,
                isShowOtherPanel: false,
                isShowEmojiPanel: false,
                clickOutSideConfig: {
                    handler: this.closeAllPanel,
                    events: ['touchstart']
                }
            }
        },
        created () {
            window.addEventListener('message', this.onIframeMessage, false)
        },
        beforeDestroy () {
            window.removeEventListener('message', this.onIframeMessage, false)
        },
        computed: {
            nowxwork () {
                return getRequest().CropID != 'wxwork_h5'
            },
            isMobile () {
                return this.$eventBus.isMobile
            },
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            isWechat () {
                return this.$eventBus.isWechat
            },
            isWechatJSSDKReady () {
                return this.$eventBus.isWechatJSSDKReady
            },
            isShowRelatedQuestion () {
                return this.hasTypingContent
                    && this.relatedQuestion.length > 0
            },
            isShowHotWords () {
                let show = false
                if (this.hotWords.enable) {
                    if (this.hotWords.human_enable&&this.hotWords.robot_enable) {
                        show = true
                    } else if (this.hotWords.human_enable&&this.chatTarget=='human') {
                        show = true
                    } else if (this.hotWords.robot_enable&&this.chatTarget=='robot') {
                        show = true
                    }
                }
                return show
            },
            activeAction () {
                if (this.isShowExtendPanel) {
                    return 'action-extend'
                }
                if (this.isShowOtherPanel) {
                    return 'action-other'
                }
                if (this.isShowEmojiPanel) {
                    return 'action-emoji'
                }
                return ''
            },
            enableFooterIphonexStyle () {
                return this.activeAction === ''
                    || this.isShowExtendPanel
            },
            isInSession () {
                return this.$store.state.isInSession
            },
            openSessionBtnStyle () {
                if (this.isMobile) {
                    return {
                        backgroundColor: this.$store.state.lingkeColor
                    }
                }
                return {}
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            },
            footerMainBackground () {
                if (this.theme === 'white') {
                    return '#fff'
                }
                return '#000'
            }
        },
        methods: {
            closeAllPanel (filterPanel) {
                const allPanelKey = [
                    'isShowExtendPanel',
                    'isShowOtherPanel',
                    'isShowEmojiPanel'
                ].filter(key => key !== filterPanel)

                allPanelKey.forEach(key => this[key] = false)
            },
            toggleExtendPanel () {
                this.closeAllPanel('isShowExtendPanel')
                this.isShowExtendPanel = !this.isShowExtendPanel
            },
            toggleOtherPanel () {
                this.closeAllPanel('isShowOtherPanel')
                this.isShowOtherPanel = !this.isShowOtherPanel
            },
            toggleEmojiPanel () {
                this.closeAllPanel('isShowEmojiPanel')
                this.switchToTypingInput()
                this.isShowEmojiPanel = !this.isShowEmojiPanel
            },
            switchToVoiceInput () {
                this.closeAllPanel()
                if (!this.isWechat) {
                    this.$toast.fail('请在微信中打开')
                    return
                }
                if (!this.$eventBus.isSocketConnected) {
                    this.$toast.fail('已断开连接，请稍后再试')
                    return
                }
                if (this.isWechatJSSDKError) {
                    this.$toast.fail('启动录音功能失败，请稍后再试')
                    return
                }
                if (!this.isWechatJSSDKReady) {
                    this.$toast.fail('录音功能正在初始化，请稍后再试')
                    return
                }
                if (this.isRecordAuth) {
                    this.chatInputType = INPUT_TYPE.VOICE
                } else {
                    this.getRecordAuth((() => {
                        this.isRecordAuth = true
                        this.chatInputType = INPUT_TYPE.VOICE
                    }).bind(this))
                }
            },
            switchToTypingInput () {
                this.closeAllPanel()
                this.chatInputType = INPUT_TYPE.TYPING
            },
            /**
             * @param { File } file
             * @returns { Boolean }
             */
            beforeRead (file) {
                const isValid = isValidFileType(file.type, UPLOAD_ACCEPT_TYPE_IMAGE)
                if (!isValid) {
                    this.$toast.fail('请选择图片')
                    return false
                }
                return isValid
            },
            /**
             * @param { Object } file
             * @param { File } file.file
             * @param { String } file.content - base64
             * @param { Object } detail
             * @param { String } detail.name
             * @param { Number } detail.index
             */
            afterRead ({ file }) {
                uploadImgBusiness(file)
            },
            triggerClickOtherPanelItem (itemName) {
                this.$eventBus.$emit(TRIGGER_CLICK_OTHER_PANEL_ITEM, itemName)
            },
            openSession () {
                this.$store.commit('setData', {
                    key: 'isInSession',
                    value: true
                })
                this.$parent.insertRobotWelcome()
            },
            onIframeMessage (event) {
                if (event.data === 'open_webot') {
                    if (!this.isInSession) {
                        this.openSession()
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "./css/index.scss";
    .open-session {
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        &.is-desktop {
            height: 170px;
        }
        &-btn {
            font-weight: 600;
            line-height: 16px;
            padding: 6px 15px;
            border: 1px dashed #1EF1C6;
            border-radius: 15px;
            color: #1EF1C6;
            cursor: pointer;
            .icon_huihua {
                margin-right: 7px;
                vertical-align: bottom;
            }
            span {
                vertical-align: bottom;
            }
        }
        &.is-mobile {
            min-height: 52px;
            padding-top: 12px;
            align-items: flex-start;
            .open-session-btn {
                font-weight: 400;
                border: none;
                color: #fff;
            }
        }
    }
</style>
